import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=1cdd70e4&scoped=true"
import script from "./userEdit.vue?vue&type=script&lang=js"
export * from "./userEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd70e4",
  null
  
)

export default component.exports